import { backendBaseUrl } from 'config.js';
import {
  buildAuthHeaders,
  dispatchSessionExpiredEvent,
  hasPendingSessionReauth,
  isLogoutSuppressingReauth,
  readStoredAuthToken,
  setSessionReauthToken
} from 'utils/authSession';
const SESSION_REAUTH_ALLOWED_PATHS = [
  '/auth/login',
  '/auth/change-password',
  '/auth/verify-2fa',
  '/auth/resend-2fa',
  '/auth/me'
];

function getAuthHeader() {
  return buildAuthHeaders();
}

function isAllowedDuringSessionReauth(path) {
  return SESSION_REAUTH_ALLOWED_PATHS.some(
    (allowedPath) => path === allowedPath || path.startsWith(`${allowedPath}?`)
  );
}

export async function apiFetch(path, { method = 'GET', headers = {}, body } = {}) {
  if (typeof window !== 'undefined' && hasPendingSessionReauth() && !isAllowedDuringSessionReauth(path)) {
    const err = new Error('SESSION_REAUTH_REQUIRED');
    err.status = 403;
    err.data = { message: 'TWO_FACTOR_EXPIRED' };
    throw err;
  }

  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const finalHeaders = {
    ...getAuthHeader(),
    ...headers
  };

  if (!isFormData && !finalHeaders['Content-Type']) {
    finalHeaders['Content-Type'] = 'application/json';
  }

  const payload =
    isFormData || body === undefined || body === null
      ? body
      : typeof body === 'string'
        ? body
        : JSON.stringify(body);

  const res = await fetch(`${backendBaseUrl}${path}`, {
    method,
    headers: finalHeaders,
    body: payload
  });
  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    const message = typeof data === 'object' && data && data.message ? data.message : res.statusText;
    const err = new Error(message || 'Request failed');
    err.status = res.status;
    err.data = data;
    if (typeof window !== 'undefined' && err.data?.message === 'TWO_FACTOR_EXPIRED' && !isLogoutSuppressingReauth()) {
      const pendingToken = err.data?.pendingToken || readStoredAuthToken();
      if (pendingToken) {
        setSessionReauthToken(pendingToken);
      }
      dispatchSessionExpiredEvent();
    }
    throw err;
  }
  return data;
}
